export default {
  channel_feed_title: 'Mensajes recientes de canales',
  mark_all_as_read_button: 'Marcar como le\u00eddo',
  view_all_message_button: 'Ver todos los mensajes',
  channel_feed_empty_text: '\u00a1Todo listo!',
};
